export default __webpack_public_path__ + "static/media/cheatday_cheesecrisps-wide@3x.3aaf33e6.jpg";